enum ActionType {
    REQUEST_EMAIL_RECIPIENTS = '[EMAIL_RECIPIENTS] GET EMAIL_RECIPIENTS',
    RECEIVE_EMAIL_RECIPIENTS = '[EMAIL_RECIPIENTS] SET EMAIL_RECIPIENTS',
}

export default ActionType
